import React, { useEffect, useState } from 'react';
import { APP_VERSION } from '../../version';

interface UpdateNotificationProps {
  registration?: ServiceWorkerRegistration;
}

const UpdateNotification: React.FC<UpdateNotificationProps> = ({ registration }) => {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (registration) {
      setShowUpdatePrompt(true);
    }
  }, [registration]);

  useEffect(() => {
    // Set up the controllerchange listener when component mounts
    const handleControllerChange = () => {
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);

    // Cleanup listener on unmount
    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
    };
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      setIsUpdating(true);
      // Tell the service worker to skip waiting and activate
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  const handleDismiss = () => {
    setShowUpdatePrompt(false);
  };

  if (!showUpdatePrompt) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: '#1e1e2d',
        color: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        zIndex: 9999,
        maxWidth: '350px',
        border: '1px solid #3b3b4d',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div style={{ flex: 1 }}>
          <h4 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600 }}>
            Update Available
          </h4>
          <p style={{ margin: 0, fontSize: '14px', color: '#b5b5c3' }}>
            A new version of TrackVAS is available. Update now to get the latest features and improvements.
          </p>
        </div>
        <button
          onClick={handleDismiss}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#b5b5c3',
            cursor: 'pointer',
            fontSize: '20px',
            padding: '0',
            marginLeft: '10px',
          }}
          aria-label="Dismiss"
        >
          &times;
        </button>
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={handleUpdate}
          disabled={isUpdating}
          style={{
            flex: 1,
            padding: '10px 16px',
            backgroundColor: '#009ef7',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: isUpdating ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: 500,
            opacity: isUpdating ? 0.6 : 1,
          }}
        >
          {isUpdating ? 'Updating...' : 'Update Now'}
        </button>
        <button
          onClick={handleDismiss}
          style={{
            padding: '10px 16px',
            backgroundColor: 'transparent',
            color: '#b5b5c3',
            border: '1px solid #3b3b4d',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          Later
        </button>
      </div>
    </div>
  );
};

export default UpdateNotification;
